export var BoxShadow;
(function (BoxShadow) {
    BoxShadow["MENU"] = "0 0 8px 1px rgba(0, 0, 0, 0.08)";
    BoxShadow["APP_UPSELL_BANNER"] = "0 2px 4px 0 rgba(0, 0, 0, 0.25)";
    BoxShadow["ZIP_CODE_SELECTION"] = "0 4px 24px rgba(0, 0, 0, 0.1)";
    BoxShadow["STICKY_DATE_PICKER"] = "0 4px 16px rgba(0, 0, 0, 0.25)";
    BoxShadow["ACCOUNT_SETTINGS_MODAL"] = "0 8px 20px rgba(0, 0, 0, 0.15)";
    BoxShadow["CHAT_INBOX"] = "0px 1px 2px rgba(0, 0, 0, 0.15), 0px 0px 2px rgba(0, 0, 0, 0.05)";
    BoxShadow["CHAT_WIDGET"] = "0px 16px 80px rgba(0,0,0,0.1), 0px 4px 16px rgba(0,0,0,0.05)";
    BoxShadow["CHIP"] = "0 2px 5px rgba(0, 0, 0, 0.18)";
    BoxShadow["MODAL"] = "0 0 15px rgba(0, 0, 0, 0.1)";
    BoxShadow["HOMEPAGE_HERO_CONTENT"] = "1px 8px 15px rgba(0, 0, 0, 0.04)";
})(BoxShadow || (BoxShadow = {}));
//# sourceMappingURL=boxShadow.js.map